export default __webpack_public_path__ + "static/media/area-19.f2f718c2.jpg";